<app-modal-shell>
  <app-modal-header>
    <h5 class="text-xl font-medium leading-normal text-gray-800">{{title}}</h5>
  </app-modal-header>
  <app-modal-body>
    <p>{{message}}</p>
  </app-modal-body>
  <app-modal-footer>
    <!-- <app-secondary-button (clickEmitter)="close()" [buttonText]="'Cancel'"></app-secondary-button>
    <app-primary-button (clickEmitter)="confirm()" [buttonText]="'Confirm'"></app-primary-button> -->
  </app-modal-footer>
</app-modal-shell>
